import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_1: FaireProductEntity = {
  token: "nyc-soap-1",
  type: "product",
  name: "Original moisturizing Botanical Bar",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e31a5446e667cc62b11c2ccfa3109ad1abbcbbc296d6d190eea07e4f4206575e.webp",
  priceDollars: 22,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.6,
  dimensions: {
    width: 3,
    height: 3,
    depth: 3,
  },
  description: "Cactus flower body exfoliant inspired by Jamaica and Hibiscus",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "organic", "exfoliant", "natural"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
